module.exports = __webpack_public_path__ + "img/alert.93a2e645.svg";